import { FormOption } from "@/types/form";
import { Patch, PatchVM } from "@/types/json-patch";
import useFormatter from "@/use/formatter";
import { FormField } from "@/types/form";

const { formatNumber, formatMoney, formatIsoToMmDdYyyy } = useFormatter();

// export function getSelectedFormOption() {

// }
export function formatInputDisplayValue(
  value: number | string | object | Date,
  type: string,
  options?: FormOption[] | null
) {
  let option = undefined as undefined | FormOption;
  console.log("formatInputDisplayValue", options);
  switch (type) {
    case "money":
      return formatMoney(value);
    case "date":
      return value ? formatIsoToMmDdYyyy(value) : "N/A";
    case "select":
      option = options?.find((f: FormOption) => f.id === Number(value));
      return option?.label || option?.name || "";
    default:
      return value;
  }
}

export function getFormChanges(changes: PatchVM[], mode: string) {
  let html = "";

  if (mode === "add") {
    changes.forEach((change: PatchVM) => {
      if (change?.hint !== null && change?.hint !== undefined) {
        html += `<tr><td class="xbefore">${change.label}</td><td class="xafter">${change.to} <span class="sc-tooltip icon-circle-question-mark" title="${change?.hint}"></span></td></tr>`;
      } else {
        html += `<tr><td class="xbefore">${change.label}</td><td class="xafter">${change.to}</td></tr>`;
      }
    });
  } else {
    changes.forEach((change: PatchVM) => {
      if (change?.hint !== null && change?.hint !== undefined) {
        html += `<tr><td class="xbefore">${change.label}</td><td class="xafter">${change.from}</td><td class="xafter">${change.to} <span class="sc-tooltip icon-circle-question-mark" title="${change?.hint}"></span></td></tr>`;
      } else {
        html += `<tr><td class="xbefore">${change.label}</td><td class="xafter">${change.from}</td><td class="xafter">${change.to}</td></tr>`;
      }
    });
  }

  return `<table class='xmodal-changes'>${html}</table>`;
}

export function getField(fieldName: string, fields: FormField[]) {
  return fields?.find((field: FormField) => field.name === fieldName);
}

// function buildPatchVM(
//   patch: Patch,
//   hint?: string | null,
//   formFields?: FormField[],
//   initialValues?: any,
//   values?: any
// ) {
//   const fieldName = patch.path.split("/")[1];
//   const field = formFields?.find(
//     (field: FormField) => field.name === fieldName
//   );

//   const fieldLabel =
//     field?.label || patch.path.replace(/([a-z])([A-Z])/g, `$1 $2`);
//   const fieldType = field?.type || "";
//   const fieldOptions = field?.options || [];
//   console.log("buildPatchVM", {
//     patch,
//     hint,
//     field,
//     fieldName,
//     fieldLabel,
//     fieldOptions,
//   });

//   return {
//     ...patch,
//     property: fieldName,
//     label: fieldLabel,
//     from: initialValues
//       ? formatInputDisplayValue(
//           initialValues[fieldName],
//           fieldType,
//           fieldOptions
//         )
//       : "",
//     to: formatInputDisplayValue(values[fieldName], fieldType, fieldOptions),
//     hint: hint,
//   };
// }
